import { Box } from 'components/Material/index'
import React, { CSSProperties } from 'react'
import { useIsMobile } from 'hooks/useIsResponsive'

interface SideBarContainerProps {
  children: React.ReactNode
}

export const SideBarContainer = ({ children }: SideBarContainerProps) => {
  const isMobile = useIsMobile()

  const sidebarStyle: CSSProperties = {
    width: isMobile ? '100%' : '390px',
    height: isMobile ? '100vh' : 'calc(100vh - 64px)',
    top: isMobile ? 0 : 64,
    display: 'flex',
    zIndex: 99999,
    flexDirection: 'column',
    flexGrow: 1,
    backgroundColor: '#fff',
    position: 'fixed',
    borderLeft: '1px solid #CAC4D0',
    right: 0,
    left: 'auto',
    padding: 0,
    overflow: 'hidden'
  }

  return <Box style={sidebarStyle}>{children}</Box>
}
